import { render, staticRenderFns } from "./DispatchFrame.vue?vue&type=template&id=5b0a6100&scoped=true&"
import script from "./DispatchFrame.vue?vue&type=script&lang=js&"
export * from "./DispatchFrame.vue?vue&type=script&lang=js&"
import style0 from "./DispatchFrame.vue?vue&type=style&index=0&id=5b0a6100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a6100",
  null
  
)

export default component.exports